import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from 'src/app/providers/common.service';
import { MessageService } from 'primeng/api';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "../../../core/custom-validator/custom-validators";
import { isEmpty } from "lodash";
import { emailRegex } from 'src/app/core/model/regex';

@Component({
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.html',
  styleUrls: ['./information-modal.component.scss'],
  providers:[MessageService]
})
export class InformationModalComponent implements OnInit {

  @Input() header: String;
  @Input() body: String;
  @Input() successFlag: boolean;
  @Input() negativeFlag: boolean;
  @Input() editPriorityId: boolean;
  @Input() priorityId: string;
  @Input() message: boolean;
  @Input() okButton: boolean;
  @Input() commitButton: boolean;
  @Input() commitButtonText: string;
  @Input() cancelButton: boolean;
  @Input() proceedBtn: boolean;
  @Input() invoiceData: any;
  @Input() invoiceId: any;
  @Input() disableButton: any;
  @Input() goToQueryParams:any;
  @Input() goToRoute:any;
  @Input() buttonName = 'Ok';
  @Input() buttonNameIso:string = 'Delete';
  @Input() btnNamePreceed:string = 'Proceed';
  @Input() gotoButton:boolean;
  @Input() enableISOLogo:boolean;
  @Input() innerHtmlContent:string = '';
  @Input() onlyCancelButton:boolean;
  @Input() showWarning: boolean = false
  @Input() tpnsListForDeletion: string[] = [];
  @Input() isLoading: boolean = false
  @Input() rentalInvoice: boolean=false;
  @Input() enable2buttons: boolean = false;
  @Input() closeBtnName:string = "Change";
  @Output() deleteIsoLogo = new EventEmitter<any>();
  @Output() confirmTest = new EventEmitter<any>();
  @Input() enableRoutingButton = false;
  @Input() queryParam = {};
  @Input() increaseBodyContentSize: any = '';
  @Input() htmlContent: string = '';
  spinLoader : boolean;
  customerForm: UntypedFormGroup;
  public isMerchantBilling: boolean = false;
  public addOnFeatureList: any = ['3D secure', 'Woocommerce', 'ACH Processor', 'Loyalty', 'Register Lite'];
  public emailControl: FormControl = new FormControl('', [Validators.required, Validators.pattern(emailRegex)]);
  @Input() showEmail = false;

  constructor(public modal: NgbActiveModal,
              public commonService: CommonService,
              private messageService:MessageService,
              private formBuilder: UntypedFormBuilder,
              
              ) { }

  ngOnInit(): void {
    this.isMerchantBilling = this.queryParam['isMerchantBilling'] || false;
    if(this.editPriorityId){
      this.customerForm = this.createCustomerForm();
    }
  }

  createCustomerForm(): UntypedFormGroup {
    return this.formBuilder.group({
      customerInfo: this.customerInfoForm(),
    });
  }   

  customerInfoForm(): UntypedFormGroup {
    const alphaRegex = /^[a-zA-Z0-9]+$/;
    const maxPriorityIdentityLength = /^.{4,15}$/;
    return this.formBuilder.group({
      priorityId: [this.priorityId || "", [
        CustomValidators.PatternValidator(alphaRegex, { hasAlphaNumeric: true }),
        CustomValidators.PatternValidator(maxPriorityIdentityLength, { hasMaxpriorityLength: true })]],
    })
  }
  closePriorityModal() {
    const priorityIdValue = this.customerForm.get('customerInfo.priorityId')?.value;
    if(!isEmpty(priorityIdValue)){
      this.modal.close(priorityIdValue);
    }
  }
  commitInvoice(){

    this.spinLoader = true;
    const {id} = this.invoiceData;
    let invoiceUrl = this.rentalInvoice?apiLinks.commitRentalInvoice:apiLinks.commitInvoice;
    this.commonService.getCommonHttpClientQueryParams(invoiceUrl, {invoiceId:id,status: this.commitButtonText.toUpperCase() == "APPROVE" ? "APPROVED": "COMMITTED"}).subscribe(res => {
      this.modal.close('success');
      this.spinLoader = false;
    },
    err => {
      console.log("in err", err);
      return this.showAlert(err, 'error');
    });

  }
  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
    this.spinLoader = false;
    // this.modal.close();
  }
  deleteISOLogo() {

  if (this.showEmail && this.emailControl.invalid) {
    this.emailControl.markAsTouched();
    return;
  }

  this.spinLoader = true;
  this.deleteIsoLogo.emit('success');
}
  proceedTest(){
    this.spinLoader = true;
    this.confirmTest.emit('Success');
  }
  
  isDisabled(): boolean {
      return this.emailControl.invalid || this.spinLoader;
  }
}